
import $ from 'jquery';
import { mapActions } from 'vuex'
//import { mapActions  } from 'vuex';
const listToMap = (list , keyProp ,valueProp) => { //處理片語對應陣列轉為 Map 物件
  const map= {};
  if(list && list.length > 0){
   list.forEach((it) => {
       map[it[keyProp]] = it[valueProp];
   });
  }
  return map;
}
Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('-');
};
Date.prototype.addDays = function(days) {
  //var date = new Date(this.valueOf());
  var date = this;
  date.setDate(date.getDate() + days);
  return date;
}
Date.prototype.addMonths = function(mm) {  
  var date = this;
  date.setMonth(date.getMonth() + mm);
  return date;
}
export const shareMixin = {
  computed: {
    $baseApiUrl (){
      return (window.ROE_APP_API || window.BaseUrl.VUE_APP_API);
    },
    $apiUrl_Quotation (){
      return this.$baseApiUrl + '/Quotation';
    },
    $apiUrl_Order (){
      return this.$baseApiUrl + '/Order';
    },
    $apiUrl_Quality (){
      return this.$baseApiUrl + '/Quality';
    },
    $apiUrl_Print (){
      return this.$baseApiUrl + '/ReportPrint';
    },
    $apiUrl_Auth (){
      return this.$baseApiUrl + '/auth';
    },
    $apiUrl_SysMenuItem (){
      return this.$baseApiUrl + '/SysMenuItem';
    },
    $userInfo (){
      let userInfo = this.$store.getters['userInfo'];
      return userInfo;
      //return null;
    },
    $isAdmin (){      
      return this.$store.state.isSystemAdmin;
    },
    $isPurchaserSuperior () {   //  採購主管
      return this.$store.state.isPurchaserSuperior;
    },
    $isRequestOnly () {   
      return this.$store.state.isRequestOnly;
    },
    $isAuditSuperior () {   //  稽核主管
      return this.$store.state.isAuditSuperior;
    },
    $isRequestSystemUser () {   //  XX廠詢價的使用者
      return this.$store.state.isRequestSystemUser;
    },
    isTw () {      
        if(this.$store.state.lang === 'zh-TW'){
          return true;
        }
        return false;
    },
    isMember (){ //供應商
      return !this.$store.state.isEmployee;
    },    
    userFactory (){
      if(this.isMember){
          const account = this.$store.getters['userInfo'].account;
          if(account){
            return account.substring(0,2);
          }
      }
      return '';
    }
    //...mapGetters('dialogConfig'),
  },
  methods: {
    ...mapActions(['updateLoading']),
    dialogShow: function(title, msgInfo, config){
      const dialogConfig = {msgTitle : title , msgHeader: title , msgText: msgInfo} ;      
      if (config) {
        dialogConfig.otherCfg = config;
      }
      this.$store.commit('doShowDialog' , dialogConfig);
    },
    listToMap (list , keyProp ,valueProp){
      return listToMap(list , keyProp ,valueProp);
    },
    jqModalShow(id){
      $('#'+id).modal('show');
    },
    jqModalHide(id){
      $('#'+id).modal('hide');
    },
    setCacheQueryParam(keyStr,params){//設定查詢條件快取暫存
      sessionStorage.setItem(keyStr ,JSON.stringify(params));
    },
    getCacheQueryParam(keyStr,srcParam){//讀取目前已經快取的參數條件
      let cacheParam = {};
      const cacheItem =sessionStorage.getItem(keyStr);
      if(cacheItem){
        cacheParam = JSON.parse(cacheItem);
      }
      Object.assign(srcParam, cacheParam);
    },
    clearCacheQueryParam(keyStr){//清除快取參數條件
      sessionStorage.removeItem(keyStr);
    },
    fixZclose(v){
      if(v === 'X'){
          return '作廢(X)';
      }else if(v === 'Y'){
          return '已結案(Y)';
      }else if(v === 'N'){
          return '未結案(N)';
      }
      return v;
    },
    openNewTabByALink (idStr , url) {      
      //const idStr = 'downLoadUnSignedPdf_Link';
      //const self = this
      //let url = 'RestApi/pdfreport/com/downloadUnSignedPdf?transCode=' + transCode
      let link = null;
      link = document.getElementById(idStr);
      if (!link) {
        link = document.createElement('a');
        link.id = idStr;
        link.style.display = 'none';
        link.target = '_blank';
        document.body.appendChild(link);
      }
      link.href = url;
      link.click();
    },
    $toolTip(v){
      if(v){
          return {
              content: v,
              appendToBody: true,
              active: false,
              placement: 'bottom-start'
          };
      }else{
          return '';//{content: ' ' ,active: false};
      }
    },
    fixDate(v){
        if(v && v.length >10){
            let newV= v.substring(0,10);
            return newV.replaceAll('-', '/');            
        }
        return v;
     },
     fixFileName (v){
        if(v) {
          let ii = v.lastIndexOf('\\');
          if(ii > -1){
              return v.substring(ii+1);
          }
        }
        return v;
     },
     getFactoryCaption(id,txt){
       if(id){
          return txt + ' ('+ id+')';
       }else{
          return txt;
       }
     }
  }
}